const MonitoringPortals = (betaTester: boolean = false) => {
  const portals = [
    {
      label: 'ComprasNet',
      value: 146,
      sourceClass: 'comprasnet',
      sourceUrl: 'http://www.comprasnet.gov.br/seguro/loginPortal.asp',
    },
    {
      label: 'ComprasNet DL',
      value: 6759,
      sourceClass: 'comprasnetdispensa',
      sourceUrl: 'http://www.comprasnet.gov.br/seguro/loginPortal.asp',
    },
    {
      label: 'Licitações-e',
      value: 177,
      sourceClass: 'licitacoese',
      sourceUrl: 'https://www.licitacoes-e.com.br/aop/index.jsp',
    },
    {
      label: 'Licitações E 2',
      value: 7225,
      sourceClass: 'licitacoese2',
      sourceUrl: 'https://licitacoes-e2.bb.com.br',
    },
    {
      label: 'Licitanet',
      value: 5204,
      sourceClass: 'licitanet',
      sourceUrl: 'https://www.licitanet.com.br',
    },
    {
      label: 'Portal de Compras Publicas',
      value: 857,
      sourceClass: 'portalcompraspublicas',
      sourceUrl: 'https://operacao.portaldecompraspublicas.com.br/18/loginext/',
    },
    {
      label: 'Plataforma Licitar Digital',
      value: 6304,
      sourceClass: 'licitardigital',
      sourceUrl: 'https://app.licitardigital.com.br/login/',
    },
    {
      label: 'Amm Licita',
      value: 7249,
      sourceClass: 'ammlicita',
      sourceUrl: 'https://app2.ammlicita.org.br/pesquisa',
    },
    {
      label: 'Banrisul',
      value: 781,
      sourceClass: 'banrisul',
      sourceUrl: 'https://pregaobanrisul.com.br/',
    },
    {
      label: 'Compras Eletrônicas RS',
      value: 4632,
      sourceClass: 'comprasrs',
      sourceUrl: 'https://www.compras.rs.gov.br',
    },
    {
      label: 'Procergs',
      value: 2072,
      sourceClass: 'procergs',
      sourceUrl: 'https://www.compras.procergs.rs.gov.br/',
    },
    {
      label: 'SIADES - Sistema Administrativo Digital do ES',
      value: 7640,
      sourceClass: 'portalsiades',
      sourceUrl: 'https://portalsiades.es.gov.br/',
    },
    {
      label: 'Selcorp',
      value: 6571,
      sourceClass: 'selcorp',
      sourceUrl: 'https://www.selcorp.com.br/pregoes',
    },
    {
      label: 'PE Integrado',
      value: 3871,
      sourceClass: 'peintegrado',
      sourceUrl: 'https://www.peintegrado.pe.gov.br',
    },
    {
      label: 'LicitApp',
      value: 7543,
      sourceClass: 'licitapp',
      sourceUrl: 'https://licitapp.com.br/',
    },
    {
      label: 'Compras FAMESP',
      value: 2050,
      sourceClass: 'famesp',
      sourceUrl: 'https://compraeletronica.famesp.org.br/Portal/Mural.aspx',
    },
    {
      label: 'E-Compras SEST SENAT',
      value: 2934,
      sourceClass: 'sestdf',
      sourceUrl: 'https://compras.sestsenat.org.br/Portal/Mural.aspx',
    },
    {
      label: 'Compras RJ (SIGA)',
      value: 2263,
      sourceClass: 'sigarj',
      sourceUrl: 'https://www.compras.rj.gov.br/Portal-Siga',
    },
    {
      label: 'Compras AP (SIGA)',
      value: 5646,
      sourceClass: 'comprasap',
      sourceUrl: 'http://siga.ap.gov.br/sgc/faces/pub/sgc/central/EditalPageList.jsp',
    },
    {
      label: 'E-Compras AM',
      value: 809,
      sourceClass: 'comprasam',
      sourceUrl: 'https://www.e-compras.am.gov.br',
    },
    {
      label: 'e-Compras Curitiba',
      value: 2080,
      sourceClass: 'prcpcuritiba',
      sourceUrl: 'https://e-compras.curitiba.pr.gov.br',
    },
    {
      label: 'Aquisições SEPLAG MT',
      value: 6212,
      sourceClass: 'seplagmt',
      sourceUrl: 'https://aquisicoes.seplag.mt.gov.br',
    },
    {
      label: 'BLL Compras',
      value: 677,
      sourceClass: 'bllcompras',
      sourceUrl: 'https://bllcompras.com',
    },
    {
      label: 'Bolsa Nacional de Compras (BNC)',
      value: 3926,
      sourceClass: 'bnccompras',
      sourceUrl: 'https://bnccompras.com',
    },
    {
      label: 'BBMNET',
      value: 1107,
      sourceClass: 'bbmnet',
      sourceUrl: 'https://bbmnet.com.br/',
    },
    {
      label: 'Portal de Compras Eletrônicas - Itaipu Binacional',
      value: 1354,
      sourceClass: 'comprasitaipu',
      sourceUrl: 'https://compras.itaipu.gov.br/portal/Mural.aspx',
    },
    {
      label: 'Portal de Compras PUBLINEXO',
      value: 2104,
      sourceClass: 'publinexo',
      sourceUrl: 'https://www.publinexo.com.br/publinexo/jsp/publico/pb_painel_pregoes.jsp?tipo=SR',
    },
    {
      label: 'Portal de Compras Manaus',
      value: 6740,
      sourceClass: 'comprasmanaus',
      sourceUrl: 'https://compras.manaus.am.gov.br/publico/',
    },
    {
      label: 'Cemig',
      value: 871,
      sourceClass: 'cemig',
      sourceUrl: 'https://app2-compras.cemig.com.br/pesquisa',
    },
    {
      label: 'Compras Campo Grande',
      value: 7154,
      sourceClass: 'comprascampogrande',
      sourceUrl:
        'http://compras.campogrande.ms.gov.br/sgc/faces/pub/sgc/pregao/AssistirPageList.jsp',
    },
    {
      label: 'Central de Compras MS',
      value: 1477,
      sourceClass: 'centralcomprasms',
      sourceUrl:
        'https://ww3.centraldecompras.ms.gov.br/sgc/faces/pub/sgc/central/EditalPageList.jsp',
    },
    {
      label: 'Compras MA (SIGA)',
      value: 5082,
      sourceClass: 'comprasma',
      sourceUrl: 'https://app2-compras.compras.ma.gov.br/pesquisa',
    },
    {
      label: 'Portal de Compra Licita MA',
      value: 7642,
      sourceClass: 'licitama',
      sourceUrl: 'https://app2-compras.licitama.com.br/pesquisa',
    },
    {
      label: 'Copasa MG',
      value: 3157,
      sourceClass: 'copasa',
      sourceUrl: 'https://www2.copasa.com.br/PortalComprasPrd/',
    },
    {
      label: 'Br Conectado',
      value: 7016,
      sourceClass: 'brconectado',
      sourceUrl: 'https://processos.brconectado.com.br/home.jsf',
    },
    {
      label: 'Prefeitura Municipal de Olimpia - SP',
      value: 3516,
      sourceClass: 'olimpia',
      sourceUrl: 'https://e-licita.olimpia.sp.gov.br:8096/compra',
    },
    {
      label: 'Prefeitura Municipal de Itápolis - SP',
      value: 2471,
      sourceClass: 'itapolis',
      sourceUrl: 'https://e-licita.itapolis.sp.gov.br:8095/compra',
    },
    {
      label: 'Prefeitura Municipal de Demerval Lobão - PI',
      value: 7338,
      sourceClass: 'demervallobao',
      sourceUrl: 'https://www.licitademervallobao.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Maranhaozinho - MA',
      value: 7339,
      sourceClass: 'maranhaozinho',
      sourceUrl: 'https://www.licitamaranhaozinho.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Humberto de Campos - MA',
      value: 7340,
      sourceClass: 'humbertocampos',
      sourceUrl: 'https://www.licitahumbertodecampos.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Itinga do Maranhão - MA',
      value: 5729,
      sourceClass: 'itingamaranhao',
      sourceUrl: 'https://www.licitaitingama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Cajari - MA',
      value: 7100,
      sourceClass: 'cajari',
      sourceUrl: 'https://www.licitacajari.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Anajatuba - MA',
      value: 7341,
      sourceClass: 'anajatuba',
      sourceUrl: 'https://www.licitaanajatuba.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de São José do Belmonte - PE',
      value: 7342,
      sourceClass: 'saojosebelmonte',
      sourceUrl: 'https://www.licitasjdobelmontepe.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Igarape Grande - MA',
      value: 7343,
      sourceClass: 'igarapegrande',
      sourceUrl: 'https://www.licitaigarapegrandema.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Buriti do Tocantins - TO',
      value: 6762,
      sourceClass: 'burititocantins',
      sourceUrl: 'https://www.licitaburitidotocantins.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Tufilandia - MA',
      value: 7052,
      sourceClass: 'tufilandia',
      sourceUrl: 'https://www.licitatufilandiama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Sucupira do Norte - MA',
      value: 7344,
      sourceClass: 'sucupiranorte',
      sourceUrl: 'https://www.licitasucupiradonortema.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Sampaio - TO',
      value: 7345,
      sourceClass: 'sampaio',
      sourceUrl: 'https://www.licitasampaio.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Grajau - MA',
      value: 7346,
      sourceClass: 'grajau',
      sourceUrl: 'https://www.licitagrajauma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Igarape do Meio - MA',
      value: 7347,
      sourceClass: 'igarapemeio',
      sourceUrl: 'https://www.licitaigarapedomeioma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de São Domingos - MA',
      value: 7348,
      sourceClass: 'saodomingos',
      sourceUrl: 'https://www.licitasaodomingosma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Alcantara - MA',
      value: 7349,
      sourceClass: 'alcantara',
      sourceUrl: 'https://www.licitaalcantara.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Vila Nova dos Martirios - MA',
      value: 7350,
      sourceClass: 'vilanovamartirios',
      sourceUrl: 'https://www.licitavilanovadosmartirios.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Colinas - MA',
      value: 7351,
      sourceClass: 'colinas',
      sourceUrl: 'https://www.licitacolinasma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Pindaré Mirim - MA',
      value: 7352,
      sourceClass: 'pindaremirim',
      sourceUrl: 'https://www.licitapindaremirim.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Chaval - CE',
      value: 7353,
      sourceClass: 'chaval',
      sourceUrl: 'https://www.licitachavalce.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Conceição do Lago Açu - MA',
      value: 7354,
      sourceClass: 'conceicaolagoacu',
      sourceUrl: 'https://www.licitalagoacuma.com.br/processos',
    },
    {
      label: 'Câmara Municipal de Santa Filomena - MA',
      value: 7355,
      sourceClass: 'camarasantafilomenamaranhao',
      sourceUrl: 'https://www.licitacmsantafilomenama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Paraibano - MA',
      value: 7356,
      sourceClass: 'paraibano',
      sourceUrl: 'https://www.licitaparaibanoma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Centro do Guilherme - MA',
      value: 7357,
      sourceClass: 'centroguilherme',
      sourceUrl: 'https://www.licitacentrodoguilhermema.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Turiaçu - MA',
      value: 7091,
      sourceClass: 'turiacu',
      sourceUrl: 'https://www.licitaturiacu.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Mirador - MA',
      value: 7358,
      sourceClass: 'mirador',
      sourceUrl: 'https://www.licitamiradorma.com.br/processos',
    },
    {
      label: 'Assembleia Legislativa do Estado do Maranhão',
      value: 1266,
      sourceClass: 'assembleialegislativama',
      sourceUrl: 'https://www.licitaalema.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de São José de Ribamar - MA',
      value: 3267,
      sourceClass: 'saojoseribamar',
      sourceUrl: 'https://www.licitasaojosederibamarma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de São Roberto - MA',
      value: 7359,
      sourceClass: 'saoroberto',
      sourceUrl: 'https://www.licitasaoroberto.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Primeira Cruz - MA',
      value: 7360,
      sourceClass: 'primeiracruz',
      sourceUrl: 'https://www.licitaprimeiracruz.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Davinópolis - MA',
      value: 6595,
      sourceClass: 'davinopolis',
      sourceUrl: 'https://www.licitadavinopolis.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Mirandiba - PE',
      value: 7367,
      sourceClass: 'mirandiba',
      sourceUrl: 'https://www.licitamirandiba.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de São José dos Basílios - MA',
      value: 7448,
      sourceClass: 'saojosebasilios',
      sourceUrl: 'https://www.licitasjbasiliosma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Esperantinópolis - MA',
      value: 7449,
      sourceClass: 'esperantinopolis',
      sourceUrl: 'https://www.licitaesperantinopolisma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Lago Verde - MA',
      value: 7450,
      sourceClass: 'lagoverde',
      sourceUrl: 'https://www.licitalagoverdema.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Presidente Médici - MA',
      value: 7451,
      sourceClass: 'presidentemedici',
      sourceUrl: 'https://www.licitapresidentemedicima.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Santo Amaro do Maranhão - MA',
      value: 7452,
      sourceClass: 'santoamaromaranhao',
      sourceUrl: 'https://www.licitasantoamaroma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Barreirinhas - MA',
      value: 7453,
      sourceClass: 'barreirinhas',
      sourceUrl: 'https://www.licitabhsma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Peri Mirim - MA',
      value: 7454,
      sourceClass: 'perimirim',
      sourceUrl: 'https://www.licitaperimirim.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Santana do Maranhão - MA',
      value: 7455,
      sourceClass: 'santanamaranhao',
      sourceUrl: 'https://www.licitasantanadomaranhao.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Nova Olinda do Maranhão - MA',
      value: 7456,
      sourceClass: 'novaolinda',
      sourceUrl: 'https://www.licitanovaolindama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Belágua - MA',
      value: 7457,
      sourceClass: 'belagua',
      sourceUrl: 'https://licitabelaguama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Urbano Santos - MA',
      value: 7458,
      sourceClass: 'urbanosantos',
      sourceUrl: 'https://www.licitaurbanosantosma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Pio XII - MA',
      value: 7380,
      sourceClass: 'pioxii',
      sourceUrl: 'https://licitapioxiima.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Domingos Mourão - MA',
      value: 7459,
      sourceClass: 'domingosmourao',
      sourceUrl: 'https://www.licitadomingosmourao.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Gilbués - PI',
      value: 7460,
      sourceClass: 'gilbues',
      sourceUrl: 'https://www.licitagilbues.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Carolina - MA',
      value: 4428,
      sourceClass: 'carolina',
      sourceUrl: 'https://www.licitacarolinama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Morros - MA',
      value: 6637,
      sourceClass: 'morros',
      sourceUrl: 'https://www.licitamorrosma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Montes Altos - MA',
      value: 7461,
      sourceClass: 'montesaltos',
      sourceUrl: 'https://www.licitamontesaltosma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Zé Doca - MA',
      value: 3105,
      sourceClass: 'zedoca',
      sourceUrl: 'https://licitazedocama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Marajá do Sena - MA',
      value: 7409,
      sourceClass: 'marajasena',
      sourceUrl: 'https://www.licitamarajadosenama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Nova Iorque - MA',
      value: 7462,
      sourceClass: 'novaiorque',
      sourceUrl: 'https://licitanovaiorquema.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Coreaú - CE',
      value: 7463,
      sourceClass: 'coreau',
      sourceUrl: 'https://www.licitacoreauce.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Brejo - MA',
      value: 7464,
      sourceClass: 'brejo',
      sourceUrl: 'https://www.licitabrejoma.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Barreiras do Piauí - PI',
      value: 7465,
      sourceClass: 'barreiraspiaui',
      sourceUrl: 'https://licitabarreiraspi.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Cariré - CE',
      value: 7466,
      sourceClass: 'carire',
      sourceUrl: 'https://licitacarirece.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Moraújo - CE',
      value: 7467,
      sourceClass: 'moraujo',
      sourceUrl: 'https://licitamoraujoce.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Palmeirais - PI',
      value: 7468,
      sourceClass: 'palmeirais',
      sourceUrl: 'https://www.licitapalmeiraispi.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Miguel Leão - PI',
      value: 7469,
      sourceClass: 'miguelleao',
      sourceUrl: 'https://licitamiguelleao.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Palmeiras do Tocantins - TO',
      value: 7470,
      sourceClass: 'palmeirastocantins',
      sourceUrl: 'https://www.licitapalmeirasto.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Amapá do Maranhão - MA',
      value: 7471,
      sourceClass: 'amapamaranhao',
      sourceUrl: 'https://licitaamapama.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Jati - CE',
      value: 7472,
      sourceClass: 'jati',
      sourceUrl: 'https://www.licitajatice.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Oeiras - PI',
      value: 7473,
      sourceClass: 'oeiras',
      sourceUrl: 'https://www.licitaoeiraspi.com.br/processos',
    },
    {
      label: 'Câmara Municipal de Barra do Corda - MA',
      value: 7474,
      sourceClass: 'camarabarracorda',
      sourceUrl: 'https://www.licitacmbarradocorda.com.br/processos',
    },
    {
      label: 'Câmara Municipal de Lago da Pedra - MA',
      value: 7475,
      sourceClass: 'camaralagopedra',
      sourceUrl: 'https://www.licitacmlagodapedrama.com.br/processos',
    },
    {
      label: 'Câmara Municipal de Primeira Cruz - MA',
      value: 7476,
      sourceClass: 'camaraprimeiracruz',
      sourceUrl: 'https://www.licitacmprimeiracruz.com.br/processos',
    },
    {
      label: 'Câmara Municipal de São José do Belmonte - PE',
      value: 7477,
      sourceClass: 'camarasaojosebelmonte',
      sourceUrl: 'https://www.licitacmsjdobelmontepe.com.br/processos',
    },
    {
      label: 'Câmara Municipal de Brejo - MA',
      value: 7478,
      sourceClass: 'camarabrejo',
      sourceUrl: 'https://www.licitacmbrejoma.com.br/processos',
    },
    {
      label: 'Câmara Municipal de Barreirinhas - MA',
      value: 7479,
      sourceClass: 'camarabarreirinhas',
      sourceUrl: 'https://www.licitacmbarreirinhas.com.br/processos',
    },
    {
      label: 'Serviço Autônomo de Água e Esgoto do Município de Oeiras - PI',
      value: 7480,
      sourceClass: 'saaeoeiras',
      sourceUrl: 'https://www.licitasaaeoeiras.com.br/processos',
    },
    {
      label: 'Prefeitura Municipal de Senhor do Bonfim - BA',
      value: 730,
      sourceClass: 'senhorbonfim',
      sourceUrl: 'https://emunicipio.com.br/pmsb/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Campo Formoso - BA',
      value: 6970,
      sourceClass: 'campoformoso',
      sourceUrl: 'https://emunicipio.com.br/pmcf/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Jaguarari - BA',
      value: 6611,
      sourceClass: 'jaguarari',
      sourceUrl: 'https://emunicipio.com.br/jaguarari/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Pindobaçu - BA',
      value: 6569,
      sourceClass: 'pindobacu',
      sourceUrl: 'https://emunicipio.com.br/pindobacu/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Filadélfia - BA',
      value: 7612,
      sourceClass: 'filadelfia',
      sourceUrl: 'https://emunicipio.com.br/filadelfia/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Caldeirão Grande - BA',
      value: 7613,
      sourceClass: 'caldeiraogrande',
      sourceUrl: 'https://emunicipio.com.br/caldeiraogrande/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Saúde - BA',
      value: 7610,
      sourceClass: 'saude',
      sourceUrl: 'https://emunicipio.com.br/saude/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Baixa Grande - BA',
      value: 6267,
      sourceClass: 'baixagrande',
      sourceUrl: 'https://emunicipio.com.br/baixagrande/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Ponto Novo - BA',
      value: 6882,
      sourceClass: 'pontonovo',
      sourceUrl: 'https://emunicipio.com.br/pontonovo/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Antônio Gonçalves - BA',
      value: 6552,
      sourceClass: 'antoniogoncalves',
      sourceUrl: 'https://emunicipio.com.br/antoniogoncalves/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Várzea Nova - BA',
      value: 7614,
      sourceClass: 'varzeanova',
      sourceUrl: 'https://emunicipio.com.br/varzeanova/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Várzea do Poço - BA',
      value: 7615,
      sourceClass: 'varzeapoco',
      sourceUrl: 'https://emunicipio.com.br/varzeadopoco/modalidade/index.php',
    },
    {
      label: 'Prefeitura Municipal de Itiúba - BA',
      value: 6940,
      sourceClass: 'itiuba',
      sourceUrl: 'https://emunicipio.com.br/itiuba/modalidade/index.php',
    },
    {
      label: 'Câmara Municipal de Campo Formoso - BA',
      value: 7616,
      sourceClass: 'camaracampoformoso',
      sourceUrl: 'https://emunicipio.com.br/camaracampoformoso/modalidade/index.php',
    },
    {
      label: 'Câmara Municipal de Ponto Novo - BA',
      value: 7617,
      sourceClass: 'camarapontonovo',
      sourceUrl: 'https://emunicipio.com.br/camarapontonovo/modalidade/index.php',
    },
    {
      label: 'Câmara Municipal de Itiúba - BA',
      value: 7618,
      sourceClass: 'camaraitiuba',
      sourceUrl: 'https://emunicipio.com.br/camaraitiuba/modalidade/index.php',
    },
    {
      label: 'Câmara Municipal de Senhor do Bonfim - BA',
      value: 7619,
      sourceClass: 'camarasenhorbonfim',
      sourceUrl: 'https://emunicipio.com.br/camarasenhordobonfim/modalidade/index.php',
    },
    {
      label: 'Câmara Municipal de Jaguarari - BA',
      value: 7620,
      sourceClass: 'camarajaguarari',
      sourceUrl: 'https://emunicipio.com.br/camarajaguarari/modalidade/index.php',
    },
    {
      label: 'Câmara Municipal de Caldeirão Grande - BA',
      value: 7621,
      sourceClass: 'camaracaldeiraogrande',
      sourceUrl: 'https://emunicipio.com.br/camaracaldeiraogrande/modalidade/index.php',
    },
    {
      label: 'Consórcio Público Interfederativo de Saúde de Senhor do Bonfim - BA',
      value: 7611,
      sourceClass: 'cpissenhorbonfim',
      sourceUrl: 'https://emunicipio.com.br/consorciosaudesb/modalidade/index.php',
    },
    {
      label: 'CDS Território Piemonte Norte do Itapicuru - BA',
      value: 7622,
      sourceClass: 'cdstpni',
      sourceUrl: 'https://emunicipio.com.br/consorcioitapicuru/modalidade/index.php',
    },
  ];

  if (betaTester)
    portals.push({
      label: 'FIEMG',
      value: 1404,
      sourceClass: 'fiemg',
      sourceUrl: 'https://compras.fiemg.com.br/Default.aspx',
    });
  return portals;
};

export default MonitoringPortals;
